import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'acris-blog-image-slider',
    label: 'acris-blog.blocks.blogImageSlider.label',
    category: 'acris-blog',
    component: 'sw-cms-block-acris-blog-image-slider',
    previewComponent: 'sw-cms-preview-acris-blog-image-slider',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: null,
        marginRight: null,
        sizingMode: 'boxed'
    },
    slots: {
        column: {
            type: 'acris-blog-image-slider'
        },
    }
});
